import {
  EResponsivePosterType,
  EResponsiveProductToShow,
} from '../types/common/module';
import i18n from './i18n';

export const formAnimationList = (animations: Array<any>) => {
  return animations.map((v) => {
    return {
      label: v?.name,
      value: v?.uuid,
    };
  });
};

export const formButtonList = formAnimationList;

export const countsOfItems = (item: EResponsiveProductToShow) => {
  switch (item) {
    case EResponsiveProductToShow.One:
      return 1;
    case EResponsiveProductToShow.Two:
      return 2;
    case EResponsiveProductToShow.Three:
      return 3;
    case EResponsiveProductToShow.Four:
      return 4;
    case EResponsiveProductToShow.Five:
      return 5;
    case EResponsiveProductToShow.Six:
      return 6;
    case EResponsiveProductToShow.TwoLandscape:
      return 2;
    case EResponsiveProductToShow.TwoPortrait:
      return 2;
  }
};

export const amountOfPosters = (item: EResponsivePosterType) => {
  const obj = {
    [EResponsivePosterType.ONE]: 1,
    [EResponsivePosterType.TWO_1_1]: 2,
    [EResponsivePosterType.TWO_1_2]: 2,
    [EResponsivePosterType.TWO_2_1]: 2,
    [EResponsivePosterType.THREE]: 3,
    [EResponsivePosterType.FOUR]: 4,
    [EResponsivePosterType.FIVE]: 5,
    [EResponsivePosterType.SIX]: 6,
  };
  return obj[item] || 0;
};

export const countsOfItems_i18n = (item: EResponsiveProductToShow) => {
  switch (item) {
    case EResponsiveProductToShow.One:
      return i18n['general.scrollout.one'];
    case EResponsiveProductToShow.Two:
      return i18n['general.scrollout.two'];
    case EResponsiveProductToShow.Three:
      return i18n['general.scrollout.three'];
    case EResponsiveProductToShow.Four:
      return i18n['general.scrollout.four'];
    case EResponsiveProductToShow.Five:
      return i18n['general.scrollout.five'];
    case EResponsiveProductToShow.Six:
      return i18n['general.scrollout.six'];
    case EResponsiveProductToShow.TwoLandscape:
      return i18n['general.scrollout.two'];
    case EResponsiveProductToShow.TwoPortrait:
      return i18n['general.scrollout.two'];
  }
};

export enum ModalField {
  Name = 'Name',
  Image = 'Image',
  ImageLink = 'ImageLink',
  ImageSetting = 'ImageSetting',
  Layer = 'Layer',
  Content = 'Content',
}

export enum LayerField {
  LayerType = 'LayerType',
  Image = 'Image',
  Text = 'Text',
  ButtonTheme = 'ButtonTheme',
  ButtonText = 'ButtonText',
  ButtonLink = 'ButtonLink',
  TextWidth = 'TextWidth',
  ImageLink = 'ImageLink',
  ImageWidth = 'ImageWidth',
  PositionOption = 'PositionOption',
  MarginToLeft = 'MarginToLeft',
  MarginToTop = 'MarginToTop',
  EntraceEffect = 'EntranceEffect',
  HoverEffect = 'HoverEffect',
}

export enum ModuleStyleField {
  TopPadding = 'TopPadding',
  BottomPadding = 'BottomPadding',
  BackgroundType = 'BackgroundType',
  FullWidth = 'FullWidth',
  MarginToBottom = 'MarginToBottom',
  MarginToLeft = 'MarginToLeft',
  MarginToRight = 'MarginToRight',
  MarginToTop = 'MarginToTop',
  BackgroundColor = 'BackgroundColor',
}

export enum ResponsiveContainer {
  ModuleStyle = 'ModuleStyle',
}

export enum ResponsiveField {
  AllTabs = 'AllTabs',
  ErrorSection = 'ErrorSection',
  PosterType = 'PosterType',
  GridType = 'GridType',
  CarouselType = 'CarouselType',
  TabType = 'TabType',
  ModuleWidth = 'ModuleWidth',
  AutoPlay = 'AutoPlay',
  IntervalTime = 'IntervalTime',
  ProductToShow = 'ProductToShow',
  ProductInRow = 'ProductInRow',
  ContentPageToShow = 'ContentPageToShow',
  ResizingOption = 'ResizingOption',
  LeaveGap = 'LeaveGap',
  Gap = 'Gap',
  ScrollOut = 'ScrollOut',
  CallToActionButton = 'CallToActionButton',
  ModuleStyle = 'ModuleStyle',
  Animation = 'Animation',
  Images = 'Images',
  Text = 'Text',
  Products = 'Products',
  Contents = 'Contents',
  Tabs = 'Tabs',
  TabStyle = 'TabStyle',
  H1Tag = 'H1Tag',
  LayoutOption = 'LayoutOption',
  RichText = 'RichText',
  SubmitButtonTheme = 'SubmitButtonTheme',
  SubmitButtonText = 'SubmitButtonText',
  SubscriptionFormStyle = 'SubscriptionFormStyle',
  CustomerInfomationFields = 'CustomerInformationFields',
  Terms = 'Terms',
  TextContent = 'TextContent',
  ProductText = 'ProductText',
  ContentText = 'ContentText',
  TextBoxWidth = 'TextBoxWidth',
  OverflowItems = 'OverflowItems',
  TabBarSetting = 'TabBarSetting',
  IframeLink = 'IframeLink',
  ModuleHeight = 'ModuleHeight',
}
